export class Environment {
    constructor(init) {
        Object.assign(this, init);
    }
}
//# sourceMappingURL=environment.js.map